import { Module } from 'vuex'
export const newDiscoverModule: Module<any, any> = {
  namespaced: true,
  state: {
    newDiscoverList: [],
    videoCategoryCardPidList: [],
    videoCategoryCardList: [],
    cursor: '',
  },
  actions: {
    getNewDiscoverList({ commit, state }, ctx) {
      const { $axios, $store, route } = ctx || {};
      const { from_user } = (route?.query || {}) as {
        from_user?: 'true' | 'false',
      };
      const searchWord = encodeURIComponent(decodeURIComponent(ctx.route.params.content || ''))
      return $axios.$$post('overseaAPI::/rest/o/w/pwa/feed/searchNew', {
        searchWord,
        fromPage: 'PWA_NEW_SEARCH',
        /**
         * @zh fromUser: 是否为用户手动点击发起搜索
         */
        fromUser: from_user === 'true',
        // 首屏视频不传 infiniteType
        // infiniteType: $store?.state?.startup?.discoverUi || "search_boost_feed",
      })
    },
    async getCategoryCardList({ commit, state }, ctx) {
      const { $axios, $store, route } = ctx
      const { from_user } = (route?.query || {}) as {
        from_user?: 'true' | 'false',
      };
      const searchWord = encodeURIComponent(decodeURIComponent(ctx.route.params.content || ''))
      const res = await $axios.$$post('overseaAPI::/rest/o/w/pwa/feed/searchNew', {
        searchWord,
        fromPage: 'PWA_NEW_SEARCH',
        fromUser: from_user === 'true',
        pcursor: $store.state.newDiscoverModule.videoCategoryCardList.length,
        infiniteType: $store?.state?.startup?.discoverUi,
      })
      if (res.result === 1) {
        commit('setCategoryCardList', {
          data: res.data.filter((item: { type: string }) => {
            return item.type === 'video-category-card' || item.type === 'picture-category-card'
          })
        })
        commit('setCategoryCardListCursor', { cursor: res.cursor })
      } else {
        commit('setCategoryCardListCursor', { cursor: 'no_more' })
      }
    },
  },
  mutations: {
    clearNewDiscoverList(state) {
      state.newDiscoverList = []
      state.videoCategoryCardPidList = []
      state.videoCategoryCardList = []
    },
    setNewDiscoverList(state, { data }: any) {
      if (!data) {
        return;
      }
      state.newDiscoverList = [...data]
      // eslint-disable-next-line array-callback-return
      state.videoCategoryCardPidList = data?.map((item: any) => {
        if (item.type === 'video-category-card') {
          return item?.data?.feeds?.photo_id_str
        } else if (item.type === 'picture-category-card') {
          return item?.data?.feeds?.pic_id_str
        }
      }).filter((item: any) => item)
    },
    setCategoryCardList(state, { data }: any) {
      state.videoCategoryCardList = [...state.videoCategoryCardList, ...data]
    },
    setCategoryCardListCursor(state, { cursor }: any) {
      state.cursor = cursor
    },
  }
}
